import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { Alert, Button, Toast } from 'react-bootstrap';
import Heading from '../heading/Heading';
import Modal from '../modal/Modal'; // Redux

import { errorDuck } from '../../ducks/error';
import { gaTracker } from '../../util';
var errorReducer = errorDuck.reducer;

var FetchError = function FetchError(props) {
  var _props$error = props.error,
      error = _props$error === void 0 ? {} : _props$error,
      errorHandler = props.errorHandler;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  useEffect(function () {
    setActive(true);
  }, [props.error]);

  var gaLink = function gaLink(error, type) {
    var data = {
      gtm: {
        uniqueEventId: '88',
        elementTarget: error.body,
        elementTitle: error.title,
        elementId: "error-".concat(type)
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var retry = function retry() {
    if (typeof error.retryHandler === 'function') {
      return error.retryHandler();
    }

    ;
    gaLink(error, "retry");
    return false; // TODO: Set some other error handler?
  };

  var handleClose = function handleClose() {
    if (typeof errorHandler === 'function') {
      errorHandler();
    }

    gaLink(error, "toast");
    return setActive(false);
  };

  var modalError = function modalError() {
    return /*#__PURE__*/React.createElement(Modal, {
      show: active,
      hide: handleClose,
      title: /*#__PURE__*/React.createElement("strong", null, "Uh oh!"),
      className: "cb-modal--error"
    }, /*#__PURE__*/React.createElement("div", null, error.title ? /*#__PURE__*/React.createElement(Heading, {
      level: "3",
      field: {
        value: error.title
      },
      className: "cb-type-title-2"
    }) : null, /*#__PURE__*/React.createElement("p", null, error.body)), error.retryHandler ? /*#__PURE__*/React.createElement("div", {
      className: "cb-l-margin-small--top"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: retry,
      className: "cb-button-primary",
      id: "error-retry"
    }, "Retry")) : null);
  };

  var toastError = function toastError() {
    var _error$options, _error$options2;

    var delay = ((_error$options = error.options) === null || _error$options === void 0 ? void 0 : _error$options.delay) ? error.options.delay : 10000;
    var autohide = ((_error$options2 = error.options) === null || _error$options2 === void 0 ? void 0 : _error$options2.autohide) ? true : false;
    var typeClass = typeof error.type !== 'undefined' ? "cb-toast--".concat(error.type) : null;

    if (!autohide) {
      delay = null;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "\n      cb-toast\n      ".concat(typeClass, "\n      "),
      role: "alert",
      "aria-live": "polite",
      "aria-atomic": "true",
      "data-delay": "10000"
    }, /*#__PURE__*/React.createElement("div", {
      role: "alert",
      "aria-live": "assertive",
      "aria-atomic": "true"
    }, /*#__PURE__*/React.createElement(Toast, {
      show: active,
      animation: true,
      onClose: handleClose,
      delay: delay,
      autohide: autohide,
      variant: "danger",
      id: "error-toast"
    }, error.title ? /*#__PURE__*/React.createElement(Toast.Header, null, /*#__PURE__*/React.createElement(Heading, {
      level: "3",
      field: {
        value: error.title
      },
      className: "cb-type-title-2"
    })) : null, /*#__PURE__*/React.createElement(Toast.Body, null, error.body))));
  };

  var renderError = function renderError() {
    switch (error.display) {
      case 'modal':
        return modalError();

      case 'toast':
        return toastError();

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, renderError());
};

export default FetchError;